import { createPinia } from 'pinia'
import type { UserModule } from '@/types'
import {createPersistedState} from 'pinia-plugin-persistedstate'
import { safeLocalStorage } from '@/composables/safeLocalStorage'

// Setup Pinia
// https://pinia.esm.dev/
export const install: UserModule = ({ isClient, initialState, app, router }) => {
  const pinia = createPinia()
  pinia.use(createPersistedState({ storage: safeLocalStorage }))
  app.use(pinia)
  // Refer to
  // https://github.com/antfu/vite-ssg/blob/main/README.md#state-serialization
  // for other serialization strategies.
  if (isClient)
    pinia.state.value = (initialState.pinia) || {}

  else
    initialState.pinia = pinia.state.value

}
